<template lang="pug">
#message-register-input
  // title
  .d-flex.flex-row.justify-content-center.mb-2
    .page-title 新規送信

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // warning messages
  template
    .mb-3
      span.error-message(v-for="errorMessage in errorMessages") {{ errorMessage }}

  // message content
  .mb-1
    span.key-name メッセージの内容
  // sender type
  .mb-3
    .d-flex.flex-row.align-items-top
      .flex-grow-1.mr-2
        b-form-select#sender-type(v-model="type" :options="typeOptions" name="type"
          v-validate="{ required: true }" aria-describedby="type" data-vv-as="宛先種別")
      .required
        RequireInput
    .error-messages.mt-1(v-if="errors.has('type')")
      label.error-message(v-for="error in errors.collect('type')") {{ error }}
  // targets
  .mb-3(v-if="type != null && type != 0")
    .d-flex.flex-row.align-items-top
      .target-add-btn.mr-2
        b-button.btn(@click="showTargetSelectModal") 宛先選択
      .target-names
        // family targets
        .family-targets.d-flex.flex-row.flex-wrap(v-if="type == 1")
          template(v-for="target in familyTargets")
            template(v-for="family in target.targets")
              button.target-name(v-show="family.isTarget == true && family.senderType == 0" @click="onSendTarget(family)") {{ family.familyName }}
              button.target-name(v-show="family.isTarget == true && family.senderType == 1" @click="onSendTarget(family)") {{ family.familyName }}（メール）
        // other user targets
        .other-user-targets.d-flex.flex-row.flex-wrap(v-if="type == 2")
          template(v-for="target in otherUserTargets")
            template(v-for="member in target.targets")
              button.target-name(v-show="member.isTarget == true && member.senderType == 0" @click="onSendTarget(member)") {{ member.memberName }}
              button.target-name(v-show="member.isTarget == true && member.senderType == 1" @click="onSendTarget(member)") {{ member.memberName }}（メール）
        // send group targets
        .send-group-targets.d-flex.flex-row.flex-wrap(v-if="type == 3")
          template(v-for="target in messageGroupTargets")
            template(v-for="group in target.targets")
              button.target-name(v-show="group.isTarget == true" @click="onSendTarget(group)") {{ group.name }}
    .error-messages.mt-1(v-if="errors.has('targets')")
      label.error-message(v-for="error in errors.collect('targets')") {{ error }}
  // tempalte
  .mb-3(v-show="planType != -1")
    .d-flex.flex-row.align-items-top
      .flex-grow-1.mr-2
        b-form-select(v-if="1 <= planType" id="template" v-model="templateId" :options="templateOptions" name="template-id")
        b-form-select.disable(v-if="planType < 1" id="disable-template" v-model="templateId" :options="[{ value: 0, text: 'ライトプラン以上で使用可能' }]" disabled)
      .div
        .nonrequired
  // title
  .mb-3
    .d-flex.flex-row.align-items-top
      .flex-grow-1.mr-2
        b-form-input(v-model="title" id="title" name="title" placeholder="タイトル" maxlength="100" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 100 }" aria-describedby="title" data-vv-as="タイトル")
      .required
        RequireInput
    .error-messages.mt-1(v-if="errors.has('title')")
      label.error-message(v-for="error in errors.collect('title')") {{ error }}
  // text
  .mb-3
    .d-flex.flex-row.align-items-top
      .flex-grow-1.mr-2
        b-form-textarea(v-model="text" id="text" name="text" placeholder="本文" rows="6" max-rows="6" maxlength="1000" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 1000, valid_link_url: true }" aria-describedby="text-live-feedback" data-vv-as="本文")
      .required
        RequireInput
    .error-messages.mt-1(v-if="errors.has('text')")
      label.error-message(v-for="error in errors.collect('text')") {{ error }}

  // line options
  .mt-2.mb-1
    span.key-name オプション設定
  .mb-2
    b-form-checkbox(v-model="addReadButton" id="add-read-button") 見ましたボタン
  .mb-2
    b-form-checkbox(v-model="addOptionText" id="add-option-text" :disabled="_addOptionTextDisabled") 既読確認メッセージ
  .mb-3
    b-form-checkbox(v-model="addReplyButton" id="add-reply-button") 返信ボタン

  // file input
  template(v-if="1 <= planType")
    .mt-2.mb-1
      span.key-name 添付ファイル
      span.comment ※最大9ファイル
    .form-input.mb-4
      b-form-file(v-model="files" name="files" :placeholder="_filePlaceholder" browse-text="画像・動画を選択" accept="video/quicktime, video/mp4, image/jpeg" multiple)
        template(#file-name="{ names }")
          span {{ files.length }}ファイル選択
      .error-messages.mt-1(v-if="errors.has('files')")
        label.error-message(v-for="error in errors.collect('files')") {{ error }}

  // buttons
  .mb-3
    ValidationAlert(v-model="showValidationAlert")
  .d-flex.flex-row.justify-content-center
    b-button.btn(@click="gotoMessageRegisterConfirm") 確認画面へ

  // loading modal
  Loading(:isBusy="isBusy" :message="loadingMessage")
  // send target modals
  SendMessageTargetFamilyModal(v-model="familyTargets" :filterOptions="familyTargetFilterOptions" :show.sync="showSendMessageTargetFamilyModal")
  SendMessageTargetOtherUserModal(v-model="otherUserTargets" :show.sync="showSendMessageTargetOtherUserModal")
  SendMessageTargetMessageGroupModal(v-model="messageGroupTargets" :selectedGroupType.sync="selectedGroupType"
    :show.sync="showSendMessageTargetMessageGroupModal")
  // send target delete modal
  OkCancelModal(v-model="showSendTargetDeleteModal" :title="sendTargetDeleteMessage" @ok="onSendTargetDeleteOk")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { MobileUrl } from "@/commons/constants/MobileUrl";
import { userStore, mobileMessageRegisterStore } from "@/store/store";
import { MobileMessageRegisterState } from "@/store/MobileMessageRegister";
import CustomValidate from "@/commons/utils/CustomValidate";
import { Getter } from "vuex-class";
import ImageFileCompression from "@/commons/utils/ImageFileCompression";

import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupMembersService from "@/commons/services/OtherUserGroupMembers";
import OtherUserGroupTypeMembersService, { OtherUserGroupTypeGroup } from "@/commons/services/OtherUserGroupTypeMembers";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import SendMessageGroupsService, { GroupType, SendMessageGroupsGetModel } from "@/commons/services/SendMessageGroups";
import SendMessageGroupMembersService from "@/commons/services/SendMessageGroupMembers";
import { PlanType } from "@/commons/services/Plans";
import SendMessageTemplatesService, { SendMessageTemplatesGetModel } from "@/commons/services/SendMessageTemplates";
import SystemError from "@/commons/models/SystemError";

import Loading from "@/mobile/basics/Loading.vue";
import ValidationAlert from "@/mobile/basics/ValidationAlertByValidator.vue";
import SendMessageTargetFamilyModal, {
  SendMessageTargetFamilyModalFilterOption,
  SendMessageTargetFamilyModalModel,
  SendMessageTargetFamilyModel
} from "@/mobile/components/modals/SendMessageTargetFamilyModal.vue";
import SendMessageTargetOtherUserModal, {
  SendMessageTargetOtherUserModalModel,
  SendMessageTargetOtherUserModel
} from "@/mobile/components/modals/SendMessageTargetOtherUserModal.vue";
import SendMessageTargetMessageGroupModal, {
  SendMessageTargetMessageGroupModalModel,
  SendMessageTargetMessageGroupModel,
  SendMessageTargetOtherUserGroupModel,
  SendMessageTargetResidentGroupModel,
  TargetType
} from "@/mobile/components/modals/SendMessageTargetMessageGroupModal.vue";
import OkCancelModal from "@/mobile/basics/OkCancelModal.vue";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";
import RequireInput from "@/mobile/basics/RequireInput.vue";
import { SendMessagesFunction } from "@/commons/services/Authorization";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

/**
 * ### 新規メッセージコンポーネント
 */
@Component({
  components: {
    Loading,
    ValidationAlert,
    SendMessageTargetFamilyModal,
    SendMessageTargetOtherUserModal,
    SendMessageTargetMessageGroupModal,
    OkCancelModal,
    ProcessIndicator,
    RequireInput
  },
  $_veeValidate: { validator: "new" }
})
export default class MessageRegisterInput extends Vue {
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバー取得サービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** 施設関係者グループ種類にひもづくメンバー取得サービス */
  @Inject("OtherUserGroupTypeMembersService") otherUserGroupTypeMembersService!: OtherUserGroupTypeMembersService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 宛先グループサービス */
  @Inject("SendMessageGroupsService") sendMessageGroupsService!: SendMessageGroupsService;
  /** 宛先グループメンバーサービス */
  @Inject("SendMessageGroupMembersService") sendMessageGroupMembersService!: SendMessageGroupMembersService;
  /** メッセージ送信テンプレートサービス */
  @Inject("SendMessageTemplatesService") sendMessageTemplatesService!: SendMessageTemplatesService;

  /** ### 新規送信入力画面での入力情報 */
  @Getter("mobileMessageRegisterState") state!: MobileMessageRegisterState;

  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: true },
    { text: "確認", current: false },
    { text: "完了", current: false }
  ];

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 宛先種別 */
  type: number | null = null;
  /** 宛先種別選択項目 */
  typeOptions: Array<{ text: string; value: number | null }> = [];
  /** 宛先(家族個別) */
  familyTargets: Array<SendMessageTargetFamilyModalModel> = [];
  /** 利用者グループフィルター用選択項目(家族個別) */
  familyTargetFilterOptions: Array<SendMessageTargetFamilyModalFilterOption> = [];
  /** 宛先(施設関係者個別) */
  otherUserTargets: Array<SendMessageTargetOtherUserModalModel> = [];
  /** 宛先(グループ) */
  messageGroupTargets: Array<SendMessageTargetMessageGroupModalModel> = [];
  /** 選択しているグループ種別 */
  selectedGroupType: TargetType = TargetType.NONE;
  /** 使用するメッセージ送信テンプレート */
  templateId: number = 0;
  /** メッセージ送信テンプレート選択肢 */
  templateOptions: Array<{ value: number; text: string }> = [];
  /** メッセージ送信テンプレートMAP */
  templateIdMap: Map<number, SendMessageTemplatesGetModel> = new Map();
  /** タイトル */
  title: string = "";
  /** 本文 */
  text: string = "";
  /** 見ましたボタンをつけるか */
  addReadButton: boolean = false;
  /** 既読確認メッセージをつけるか */
  addOptionText: boolean = false;
  /** 返信ボタンをつけるか */
  addReplyButton: boolean = false;
  /** 添付ファイル */
  files: Array<File> = [];

  /** エラーメッセージ */
  errorMessages: string[] = [];

  /** 読み込み中モーダル表示可否 */
  isBusy: boolean = false;
  /** 読み込み中モーダルメッセージ */
  loadingMessage: string = "読込み中";

  /** 「家族個別」宛先選択モーダル表示可否 */
  showSendMessageTargetFamilyModal: boolean = false;
  /** 「施設関係者個別」宛先選択モーダル表示可否 */
  showSendMessageTargetOtherUserModal: boolean = false;
  /** 「グループ」宛先選択モーダル表示可否 */
  showSendMessageTargetMessageGroupModal: boolean = false;

  /** 宛先削除モーダル表示可否 */
  showSendTargetDeleteModal: boolean = false;
  /** 宛先削除モーダルメッセージ */
  sendTargetDeleteMessage: string = "";
  /** 宛先削除対象の一時保存 */
  sendTargetDeleteTarget: any = null;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  @Watch("templateId")
  public changeTemplateId(newTemplateId: number): void {
    if (newTemplateId == 0) {
      this.title = "";
      this.text = "";
      this.addOptionText = false;
      this.addReadButton = false;
      this.addReplyButton = false;
    }

    const selectedTemplate: SendMessageTemplatesGetModel | undefined = this.templateIdMap.get(newTemplateId);
    if (selectedTemplate == undefined) {
      return;
    }

    this.title = selectedTemplate.title ? selectedTemplate.title : "";
    this.text = selectedTemplate.text ? selectedTemplate.text : "";
    this.addOptionText = selectedTemplate.addOptionText;
    this.addReadButton = selectedTemplate.addReadButton;
    this.addReplyButton = selectedTemplate.addReplyButton;

    return;
  }

  get _filePlaceholder(): string {
    if (0 < this.files.length) {
      return `${this.files.length}ファイル選択`;
    } else {
      return "";
    }
  }

  /**
   * ### 見ましたボタンの値監視
   *
   * - 見ましたボタンがfalseになったら既読確認メッセージもfalseにする
   */
  @Watch("addReadButton")
  public changeAddReadButton(): void {
    if (this.addReadButton == false) {
      this.addOptionText = false;
    }
    return;
  }

  /** ### 既読確認の非活性化を返す */
  get _addOptionTextDisabled(): boolean {
    return !this.addReadButton;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // メッセージ送信テンプレートを取得して選択肢、MAPを作成する
    const sendMessageTemplates: Array<SendMessageTemplatesGetModel> = await this.getSendMessageTemplates();
    const templateOptions: Array<{ value: number; text: string }> = this.createTemplateOpstions(sendMessageTemplates);
    this.templateOptions = templateOptions;
    const templateIdMap: Map<number, SendMessageTemplatesGetModel> = this.createTemplateIdMap(sendMessageTemplates);
    this.templateIdMap = templateIdMap;

    await this.createView();

    return;
  }

  /**
   * ### メッセージ送信テンプレートを取得する
   */
  public async getSendMessageTemplates(): Promise<Array<SendMessageTemplatesGetModel>> {
    const results: Array<SendMessageTemplatesGetModel> = await this.sendMessageTemplatesService.gets(userStore);
    return results;
  }

  /**
   * ### メッセージ送信テンプレートの選択肢を作成する
   */
  public createTemplateOpstions(templates: Array<SendMessageTemplatesGetModel>): Array<{ value: number; text: string }> {
    let options: Array<{ value: number; text: string }> = [];

    options.push({ value: 0, text: `テンプレートを使用しない` });

    for (const template of templates) {
      options.push({ value: template.id, text: template.name });
    }

    return options;
  }

  /**
   * ### テンプレートIDのMAPを作成する
   */
  public createTemplateIdMap(templates: Array<SendMessageTemplatesGetModel>): Map<number, SendMessageTemplatesGetModel> {
    let map: Map<number, SendMessageTemplatesGetModel> = new Map<number, SendMessageTemplatesGetModel>();

    for (const template of templates) {
      map.set(template.id, template);
    }

    return map;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - プランによっては宛先種別を作り直す
   */
  public async createView(): Promise<void> {
    this.isBusy = true;

    this.planType = userStore.facility.planType;

    const typeOptions: Array<{ text: string; value: number | null }> = this.createTypeOptions();
    this.typeOptions = typeOptions;

    this.restoreInputValues();

    this.isBusy = false;

    return;
  }

  /**
   * ### 宛先選択肢を作成する
   */
  public createTypeOptions(): Array<{ text: string; value: number | null }> {
    const sendMessagesFunction: SendMessagesFunction = userStore.loginUser.permissions.sendMessagesFunction;
    const typeOptions: Array<{ text: string; value: number | null }> = [{ text: "宛先種別を選択してください", value: null }];

    // フリープラン
    if (this.planType == PlanType.FREE) {
      if (sendMessagesFunction.useSendTargetToAllFamily) {
        typeOptions.push({ text: "家族全員", value: 0 });
      }
      if (sendMessagesFunction.useSendTargetToFamily) {
        typeOptions.push({ text: "家族個別", value: 1 });
      }
    }
    // ライトプラン
    else if (this.planType == PlanType.LIGHT) {
      if (sendMessagesFunction.useSendTargetToAllFamily) {
        typeOptions.push({ text: "家族全員", value: 0 });
      }
      if (sendMessagesFunction.useSendTargetToFamily) {
        typeOptions.push({ text: "家族個別", value: 1 });
      }
      if (
        sendMessagesFunction.useSendTargetToFamilySendMessageGroup ||
        sendMessagesFunction.useSendTargetToOtherUserSendMessageGroup ||
        sendMessagesFunction.useSendTargetToResidentGroup ||
        sendMessagesFunction.useSendTargetToOtherUserGroup
      ) {
        typeOptions.push({ text: "グループ", value: 3 });
      }
    }
    // それ以外（ベーシック以上）
    else {
      if (sendMessagesFunction.useSendTargetToAllFamily) {
        typeOptions.push({ text: "家族全員", value: 0 });
      }
      if (sendMessagesFunction.useSendTargetToFamily) {
        typeOptions.push({ text: "家族個別", value: 1 });
      }
      if (sendMessagesFunction.useSendTargetToOtherUser) {
        typeOptions.push({ text: "施設関係者個別", value: 2 });
      }
      if (
        sendMessagesFunction.useSendTargetToFamilySendMessageGroup ||
        sendMessagesFunction.useSendTargetToOtherUserSendMessageGroup ||
        sendMessagesFunction.useSendTargetToResidentGroup ||
        sendMessagesFunction.useSendTargetToOtherUserGroup
      ) {
        typeOptions.push({ text: "グループ", value: 3 });
      }
    }

    return typeOptions;
  }

  /**
   * ### 入力情報の復元
   *
   * - storeに入力情報が保持されていれば復元する
   * - 確認画面から本画面に遷移してくる間に他ユーザーにプランが変更される可能性があるため、プランが変更されていたら値復元はしない
   * - 値復元しない場合はメッセージを表示する
   * - 宛先情報は宛先種別に応じて復元する
   * - 復元後はstoreの内容をリセットする
   */
  public restoreInputValues(): void {
    this.errorMessages = [];
    if (this.state.planType != PlanType.UNKNOWN && this.planType != this.state.planType) {
      this.errorMessages.push("ご契約プランが変更されたため、再度入力してください");
    } else if (this.state.exist == true) {
      this.type = this.state.type;

      switch (this.state.type) {
        case SenderType.FAMILY:
          this.familyTargets = this.state.targets;
          break;
        case SenderType.OTHER_USER:
          this.otherUserTargets = this.state.targets;
          break;
        case SenderType.GROUP:
          this.messageGroupTargets = this.state.targets;
          break;
        default:
          break;
      }

      this.title = this.state.title;
      this.text = this.state.text;
      this.addReadButton = this.state.addReadButton;
      this.addOptionText = this.state.addOptionText;
      this.addReplyButton = this.state.addReplyButton;
      this.files = this.state.files;
    }

    mobileMessageRegisterStore.resetMobileMessageRegisterState();

    return;
  }

  /**
   * ### 宛先選択モーダルを表示する
   *
   * - モバイルなので宛先種別に応じて宛先候補を取得する
   */
  public async showTargetSelectModal(): Promise<void> {
    this.isBusy = true;

    switch (this.type) {
      case SenderType.FAMILY: {
        if (this.familyTargets.length <= 0) {
          const familyTargets: Array<SendMessageTargetFamilyModalModel> = await this.createFamilyTargets();
          this.familyTargets = familyTargets;
          // 家族個別のみ利用者グループフィルタリングが必要なのでフィルタリング用選択項目を作成する
          this.familyTargetFilterOptions = await this.createFamilyTargetFilterOptions(familyTargets);
        }

        this.showSendMessageTargetFamilyModal = true;
        break;
      }
      case SenderType.OTHER_USER: {
        if (this.otherUserTargets.length <= 0) {
          this.otherUserTargets = await this.createOtherUserTargets();
        }
        this.showSendMessageTargetOtherUserModal = true;
        break;
      }
      case SenderType.GROUP: {
        if (this.messageGroupTargets.length <= 0) {
          this.messageGroupTargets = await this.createMessageGroupTargets();
        }
        this.showSendMessageTargetMessageGroupModal = true;
        break;
      }
      default:
        break;
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 「家族個別」の宛先対象を作成する
   */
  public async createFamilyTargets(): Promise<Array<SendMessageTargetFamilyModalModel>> {
    const families: Array<FamilyGetModel> = await this.getMaskedFamilies();
    if (families.length == 0) {
      return [];
    }

    let targets: Array<SendMessageTargetFamilyModalModel> = [];
    let residentId: number = families[0].id;
    let targetResident: SendMessageTargetFamilyModalModel = this.createTargetResident(families[0]);
    targetResident.targets.push(this.createTargetFamily(families[0]));

    for (let i = 1; i < families.length; i++) {
      const family: FamilyGetModel = families[i];
      // 利用者が変わったら新しい利用者を作って、ひもづく家族を追加する
      if (residentId != family.id) {
        targets.push(targetResident);
        targetResident = this.createTargetResident(family);
        targetResident.targets.push(this.createTargetFamily(family));
        residentId = family.id;
      }
      // 利用者が変わらなければ利用者に家族を追加する
      else {
        const targetFamily = this.createTargetFamily(family);
        targetResident.targets.push(targetFamily);
      }
    }
    // 最終の利用者を追加する
    targets.push(targetResident);

    return targets;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   *
   * - ユーザーの権限で利用者グループマスキングされた家族を取得する
   */
  public async getMaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      response = await this.familiesService.getsInFacility(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 「家族個別」のラベルとなる利用者を作成する
   */
  public createTargetResident(family: FamilyGetModel): SendMessageTargetFamilyModalModel {
    let target: SendMessageTargetFamilyModalModel = {
      name: `${family.name}（${family.room}）`,
      familyRelation: family.familyRelation,
      familyPosition: family.familyPosition,
      groupId: family.groupId,
      targets: [],
      show: true
    };

    return target;
  }

  /**
   * ### 「家族個別」の送信対象の家族を作成する
   */
  public createTargetFamily(family: FamilyGetModel): SendMessageTargetFamilyModel {
    return {
      ...family,
      isTarget: false,
      show: true
    };
  }

  /**
   * ### 「家族個別」で利用者グループフィルタリングするための選択項目を作成する
   *
   * - 全てを用意する
   * - その他の項目は利用者が存在する利用者グループのみとする
   */
  public async createFamilyTargetFilterOptions(familyTargets: Array<SendMessageTargetFamilyModalModel>): Promise<Array<SendMessageTargetFamilyModalFilterOption>> {
    let filterOptions: Array<SendMessageTargetFamilyModalFilterOption> = [];

    filterOptions.push({
      value: "0",
      text: "全て"
    });

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();

    for (const group of residentGroups) {
      let families: Array<SendMessageTargetFamilyModel> = [];
      for (const familyTarget of familyTargets) {
        for (const family of familyTarget.targets) {
          if (family.groupId == group.id) {
            families.push(family);
          }
        }
      }
      if (0 < families.length) {
        filterOptions.push({
          value: String(group.id),
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /**
   * ### 利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 「施設関係者」の宛先対象を作成する
   *
   * - グループメンバーでネストして画面表示するため、構成を合わせる
   * - メンバーがいない施設関係者グループは表示しない
   */
  public async createOtherUserTargets(): Promise<Array<SendMessageTargetOtherUserModalModel>> {
    // 宛先対象の元となる施設関係者グループを取得する
    // 0件なら宛先対象は空配列を返す
    const groups: Array<OtherUserGroupTypeGroup> = await this.getOtherUserGroupMembers();
    if (groups.length == 0) {
      return [];
    }

    // グループ種類名を格納する
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypesMap: Map<number, string> = this.createOtherUserGroupTypesMap(otherUserGroupTypes);

    let SendMessageTargetOtherUserModalModel: Array<SendMessageTargetOtherUserModalModel> = [];
    for (const group of groups) {
      const groupTypeName: string | undefined = otherUserGroupTypesMap.get(group.groupTypeId);

      if (group.memberCount < 1) {
        continue;
      }

      for (let member of group.members) {
        member.isTarget = false;
        member.show = true;
      }

      SendMessageTargetOtherUserModalModel.push({
        name: `${group.name}・${groupTypeName}`,
        targets: group.members,
        show: true
      });
    }

    return SendMessageTargetOtherUserModalModel;
  }

  /**
   * ### グループ-メンバーを取得する
   */
  public async getOtherUserGroupMembers(): Promise<Array<OtherUserGroupTypeGroup>> {
    const targets: Array<OtherUserGroupTypeGroup> = await this.otherUserGroupTypeMembersService.get(userStore, -1);
    return targets;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 画面表示用に施設関係者グループ種類のMAPを作成する
   */
  public createOtherUserGroupTypesMap(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Map<number, string> {
    let map: Map<number, string> = new Map<number, string>();
    for (const type of otherUserGroupTypes) {
      map.set(type.id, type.name);
    }
    return map;
  }

  /**
   * ### 「宛先グループ」の宛先対象を作成する
   *
   * - フリー、ライトプランは施設関係者グループを非表示にする
   */
  public async createMessageGroupTargets(): Promise<Array<SendMessageTargetMessageGroupModalModel>> {
    const sendMessageTargetMessageGroupModalModel: Array<SendMessageTargetMessageGroupModalModel> = [];

    // 宛先グループの選択肢作成
    const sendMessagesFunction: SendMessagesFunction = userStore.loginUser.permissions.sendMessagesFunction;
    if (sendMessagesFunction.useSendTargetToFamilySendMessageGroup || (PlanType.BASIC <= this.planType && sendMessagesFunction.useSendTargetToOtherUserSendMessageGroup)) {
      const messageGroups: Array<SendMessageGroupsGetModel> = await this.getMessageGroups();
      const targetGroupsForFamily: Array<SendMessageTargetMessageGroupModel> = [];
      const targetGroupForOtherUser: Array<SendMessageTargetMessageGroupModel> = [];
      for (const group of messageGroups) {
        if (group.type == GroupType.FAMILY) {
          targetGroupsForFamily.push({
            ...group,
            isTarget: false,
            show: true,
            memberCount: group.members.length
          });
        } else if (group.type == GroupType.OTHER_USER) {
          targetGroupForOtherUser.push({
            ...group,
            isTarget: false,
            show: true,
            memberCount: group.members.length
          });
        }
      }
      // 選択肢をモーダル表示用の情報に整形する
      if (sendMessagesFunction.useSendTargetToFamilySendMessageGroup) {
        sendMessageTargetMessageGroupModalModel.push({
          name: "宛先グループ（家族）",
          targets: targetGroupsForFamily,
          show: true,
          type: TargetType.SEND_MESSAGE_GROUP_FOR_FAMILY
        });
      }
      if (PlanType.BASIC <= this.planType && sendMessagesFunction.useSendTargetToOtherUserSendMessageGroup) {
        sendMessageTargetMessageGroupModalModel.push({
          name: "宛先グループ（施設関係者）",
          targets: targetGroupForOtherUser,
          show: true,
          type: TargetType.SEND_MESSAGE_GROUP_FOR_OTHER_USER
        });
      }
    }

    // 利用者グループの選択肢作成
    if (PlanType.LIGHT <= this.planType && sendMessagesFunction.useSendTargetToResidentGroup) {
      // 全家族を取得して利用者グループにひもづく家族人数を集計する
      const allFamily: Array<FamilyGetModel> = await this.getNonmaskedFamilies();
      const residentGroupMemberCountMap = new Map<number, number>();
      for (const family of allFamily) {
        let memberCount: number | undefined = residentGroupMemberCountMap.get(family.groupId);
        if (memberCount) {
          memberCount++;
          residentGroupMemberCountMap.set(family.groupId, memberCount);
        } else {
          residentGroupMemberCountMap.set(family.groupId, 1);
        }
      }
      // 家族が1人以上所属する利用者グループを選択肢の対象にする
      const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
      const targetResidentGroups: Array<SendMessageTargetResidentGroupModel> = [];
      for (const group of residentGroups) {
        const memberCount: number | undefined = residentGroupMemberCountMap.get(group.id);
        targetResidentGroups.push({
          ...group,
          isTarget: false,
          show: true,
          memberCount: memberCount ? memberCount : 0
        });
      }
      // 選択肢をモーダル表示用の情報に整形する
      sendMessageTargetMessageGroupModalModel.push({
        name: "利用者グループ",
        targets: targetResidentGroups,
        show: true,
        type: TargetType.RESIDENT_GROUP
      });
    }

    // 施設関係者グループの選択肢作成
    if (PlanType.LIGHT <= this.planType && sendMessagesFunction.useSendTargetToOtherUserGroup) {
      // 全施設関係者メンバーを取得して施設関係者グループにひもづくメンバー人数を集計する
      const otherUserGroupMembersInFacility: Array<OtherUserGroup> = await this.getOtherUserGroupMembersInFacility();
      const otherUserGroupMemberCountMap = new Map<number, number>();
      for (const member of otherUserGroupMembersInFacility) {
        let memberCount: number | undefined = otherUserGroupMemberCountMap.get(member.id);
        if (memberCount) {
          memberCount++;
          otherUserGroupMemberCountMap.set(member.id, memberCount);
        } else {
          otherUserGroupMemberCountMap.set(member.id, 1);
        }
      }
      // メンバーが1人以上所属する施設関係者グループを選択肢の対象にする
      const otherUserGroups: Array<OtherUserGroup> = await this.getOtherUserGroups();
      const targetOtherUserGroups: Array<SendMessageTargetOtherUserGroupModel> = [];
      for (const group of otherUserGroups) {
        const memberCount: number | undefined = otherUserGroupMemberCountMap.get(group.id);
        targetOtherUserGroups.push({
          ...group,
          isTarget: false,
          show: true,
          memberCount: memberCount ? memberCount : 0
        });
      }
      // 選択肢をモーダル表示用の情報に整形する
      sendMessageTargetMessageGroupModalModel.push({
        name: "施設関係者グループ",
        targets: targetOtherUserGroups,
        show: true,
        type: TargetType.OTHER_USER_GROUP
      });
    }

    return sendMessageTargetMessageGroupModalModel;
  }

  /**
   * ### 宛先グループを取得する
   */
  public async getMessageGroups(): Promise<Array<SendMessageGroupsGetModel>> {
    const groups: Array<SendMessageGroupsGetModel> = await this.sendMessageGroupsService.gets(userStore);
    return groups;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getNonmaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      const params: any = {
        masking: "none"
      };
      response = await this.familiesService.getsInFacility(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount,
            masking: "none"
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 施設にひもづく施設関係者グループメンバーを取得する
   */
  public async getOtherUserGroupMembersInFacility(): Promise<Array<OtherUserGroup>> {
    const response: Array<OtherUserGroup> = await this.otherUserGroupMembersService.get(userStore);
    return response;
  }

  /**
   * ### 施設関係者グループを取得する
   */
  public async getOtherUserGroups(): Promise<Array<OtherUserGroup>> {
    const response: Array<OtherUserGroup> = await this.otherUserGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### フッターを表示する
   */
  public showFooter(): void {
    this.$emit("updateShowFooter", true);
    return;
  }

  /**
   * ### フッターを非表示にする
   */
  public hideFooter(): void {
    this.$emit("updateShowFooter", false);
    return;
  }

  /**
   * ### 宛先の押下イベント
   *
   * - 削除対象の宛先を保持する
   * - 削除用のメッセージを作成する
   * - 宛先削除モーダルを表示する
   */
  public onSendTarget(target: any): void {
    switch (this.type) {
      case SenderType.FAMILY: {
        const deleteTarget: SendMessageTargetFamilyModel = target as SendMessageTargetFamilyModel;
        const message: string = `${deleteTarget.familyName}を宛先から削除しますか？`;
        this.sendTargetDeleteTarget = deleteTarget;
        this.sendTargetDeleteMessage = message;
        break;
      }
      case SenderType.OTHER_USER: {
        const deleteTarget: SendMessageTargetOtherUserModel = target as SendMessageTargetOtherUserModel;
        const message: string = `${deleteTarget.memberName}を宛先から削除しますか？`;
        this.sendTargetDeleteTarget = deleteTarget;
        this.sendTargetDeleteMessage = message;
        break;
      }
      case SenderType.GROUP: {
        const deleteTarget: SendMessageTargetMessageGroupModel = target as SendMessageTargetMessageGroupModel;
        const message: string = `${deleteTarget.name}を宛先から削除しますか？`;
        this.sendTargetDeleteTarget = deleteTarget;
        this.sendTargetDeleteMessage = message;
        break;
      }
      default:
        break;
    }

    this.showSendTargetDeleteModal = true;

    return;
  }

  /**
   * ### 宛先対象から削除する
   */
  public onSendTargetDeleteOk(): void {
    this.sendTargetDeleteTarget.isTarget = false;

    return;
  }

  /**
   * ### 新規送信のプレビュー画面へ遷移する
   *
   * - バリデーションチェック
   * - 宛先のバリデーションは「家族全員」以外の場合のみ実施する
   * - バリデーションチェックでエラーが無ければ以下を実施
   *   - ストアに入力情報を格納
   *   - 確認画面へ遷移する
   */
  public async gotoMessageRegisterConfirm(): Promise<void> {
    // バリデーションエラーリセット、自前で設定しているものは自前でリセットしなくてはいけない
    this.$validator.errors.remove("files");
    this.$validator.errors.remove("targets");

    const validationResult: boolean = await this.$validator.validateAll();
    const fileValidationResult: boolean = this.fileValidate(this.files);
    let targetsValidateResult: boolean = true;
    if (this.type != SenderType.ALL_FAMILY) {
      switch (this.type) {
        case SenderType.FAMILY:
          targetsValidateResult = this.targetsValidate(this.familyTargets);
          break;
        case SenderType.OTHER_USER:
          targetsValidateResult = this.targetsValidate(this.otherUserTargets);
          break;
        case SenderType.GROUP:
          targetsValidateResult = this.targetsValidate(this.messageGroupTargets);
          break;
        default:
          break;
      }
    }

    if (validationResult == true && fileValidationResult == true && targetsValidateResult == true) {
      this.showValidationAlert = false;
      this.isBusy = true;

      let targets: Array<any> = [];
      switch (this.type) {
        case SenderType.FAMILY:
          targets = this.familyTargets;
          break;
        case SenderType.OTHER_USER:
          targets = this.otherUserTargets;
          break;
        case SenderType.GROUP:
          targets = this.messageGroupTargets;
          break;
        default:
          break;
      }

      let sendTargetFiles: Array<File> = [];
      for (const file of this.files) {
        if (file.type == "image/jpeg") {
          try {
            const compressedFile: File | undefined = await ImageFileCompression.imageCompression(file, "image/jpeg", 1 * 1024 * 1024, 4096, 4096);
            if (compressedFile) {
              sendTargetFiles.push(compressedFile);
            }
          } catch (error) {
            this.$validator.errors.add({
              field: "files",
              msg: `形式ではないか、破損しています。お手数ですが、再度選択し直してください。`
            });
            this.showValidationAlert = true;
            return;
          }
        } else {
          sendTargetFiles.push(file);
        }
      }

      const state: MobileMessageRegisterState = {
        type: this.type != null ? this.type : -1,
        targets: targets,
        title: this.title,
        text: this.text,
        addReadButton: this.addReadButton,
        addOptionText: this.addOptionText,
        addReplyButton: this.addReplyButton,
        files: sendTargetFiles,
        planType: userStore.facility.planType,
        exist: true
      };
      mobileMessageRegisterStore.updateMobileMessageRegisterState({ state: state });

      this.isBusy = false;

      this.$router.push(MobileUrl.MessageRegisterConfirm);
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### ファイルのバリデーション
   *
   * - ファイル入力はバリデーターを使えないので、自前でバリデーションを実施する
   * - ファイル数バリデーション
   * - ファイル種別バリデーション
   * - ファイルサイズバリデーション
   * - バリデーションでエラーの場合はファイルをリセットする
   */
  public fileValidate(files: Array<File>): boolean {
    for (const file of files) {
      if (!file || !file.name || file.size == 0) {
        this.$validator.errors.add({ field: "files", msg: `ファイルが破損等をしている可能性があり、ファイルを認識することができません。お手数ですが、再度選択し直してください。` });
        return false;
      }
    }
    if (9 < files.length) {
      this.$validator.errors.add({ field: "files", msg: "添付ファイル最大登録ファイル数以上は登録できません" });
      return false;
    }
    for (const file of files) {
      if (file.type != "image/jpeg" && file.type != "video/mp4" && file.type != "video/quicktime") {
        this.$validator.errors.add({ field: "files", msg: `${file.name}はjpg、mp4、mov以外の拡張子のため登録できません` });
        return false;
      }
      const fileSize: number = 1024 * 1024 * 200;
      if (file.type != "video/mp4" && file.type != "video/quicktime") {
        if (fileSize < file.size) {
          this.$validator.errors.add({ field: "files", msg: `${file.name}のファイルサイズが200MBを超えているため登録できません` });
          return false;
        }
      }
    }

    return true;
  }

  /**
   * ### 宛先のバリデーション
   */
  public targetsValidate(targets: Array<any>): boolean {
    if (targets.length <= 0) {
      this.$validator.errors.add({ field: "targets", msg: "宛先は必須です" });
      return false;
    }
    return true;
  }
}

export enum SenderType {
  UNKNOWN = -1,
  ALL_FAMILY = 0,
  FAMILY = 1,
  OTHER_USER = 2,
  GROUP = 3
}
</script>

<style lang="scss" scopeed>
@import "../../../styles/mobile/_colors.scss";

#message-register-input {
  .validation-label {
    color: $font-strong;
    background-color: $bg-default;
    font-size: 0.8rem;
    border: 1px solid $font-strong;
    padding: 1px 3px;
  }
  .comment {
    font-size: 0.8rem;
  }

  .target-add-btn {
    min-width: 6rem;
  }
  .target-names {
    .target-name {
      color: $font-key;
      background-color: $bg-default;
      min-height: 2.3rem !important;
      padding: 2px 10px !important;
      margin: 0 0.5rem 0.5rem 0;
      border-radius: 0.25rem;
      border: 1px solid $border-default;
      word-break: break-all;
    }
  }

  .nonrequired,
  .required {
    min-width: 2.4rem;
    width: 2.4rem;
  }

  .custom-file-label::after {
    color: $font-btn;
    background-color: $bg-btn;
  }
}
</style>
